/*
 * @Description:
 * @Author: xiawenlong
 * @Date: 2021-05-25 19:19:47
 * @LastEditors: xiawenlong
 * @LastEditTime: 2022-07-27 17:14:50
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import "@/api/http.js";
import ElementUI from "element-ui";
import "@/style/element-color/index.css";
import "@/style/base.css";
import { setCookie, getCookie } from "@/utils/cookies";
import VueClipboard from "vue-clipboard2";
import WebIM from "./utils/WebIM";
import store from "@/store";
import VueCropper from "vue-cropper";
import SlideVerify from "vue-monoplasty-slide-verify";
import MetaInfo from "vue-meta-info";
import VueLazyload from "vue-lazyload";
import websocket from "vue-native-websocket";
Vue.use(SlideVerify);
Vue.use(VueCropper);
Vue.use(VueClipboard);
Vue.use(ElementUI);
Vue.use(MetaInfo);
Vue.use(VueLazyload, {
  preLoad: 0.9,
  attempt: 1
});
// 只对 Chrome/Edge 之类浏览器处理，Safari 不建议这样做
const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

let rawCanPlayType = null;

if (!isSafari) {
  rawCanPlayType = HTMLMediaElement.prototype.canPlayType;

  HTMLMediaElement.prototype.canPlayType = function (type) {
    const t = String(type || '').toLowerCase();

    // 禁止浏览器向播放器声明"我可以原生播放 HLS"
    if (
      t.includes('application/vnd.apple.mpegurl') ||
      t.includes('application/x-mpegurl') ||
      t.includes('mpegurl') ||
      t.includes('m3u8')
    ) {
      return '';
    }

    return rawCanPlayType.call(this, type);
  };
}
Vue.use(websocket, "", {
  connectManually: true, // 手动连接
  format: "json", // json格式
  reconnection: true, // 是否自动重连
  reconnectionAttempts: 5, // 自动重连次数
  reconnectionDelay: 2000 // 重连间隔时间
});
Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
  document.querySelector(".el-main") &&
    document.querySelector(".el-main").scrollTo(0, 0);
  //注册一个全局守卫，作用是在路由跳转前，对路由进行判断，防止未登录的用户跳转到其他需要登录的页面去
  if (to.meta.role) {
    if (getCookie("myToken")) {
      next();
    } else {
      setCookie("redirectUrl", window.location.href);
      const Url = window.location.host;
      if (Url === "organ-test.i-ronge.com") {
        //测试网址
        window.location.href = "https://login-center-test.i-ronge.com/#/login";
      } else if (Url === "localhost:8080") {
        // 本地跳转
        window.location.href = "https://login-center-test.i-ronge.com/#/login";
      } else if (Url === "organ.i-ronge.com") {
        // 默认正式
        window.location.href = "https://login-center.i-ronge.com/#/login";
      } else if (Url === "business.i-ronge.com") {
        // 默认正式
        window.location.href = "https://login-center.i-ronge.com/#/login";
      }
    }
  }
  if (to.path == "/login") {
    next({
      path: "/"
    });
  }
  next();
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  WebIM,
  store,
  components: {
    App
  },
  template: "<App/>",
  data: {
    eventHub: new Vue()
  },
  mounted() {
    document.dispatchEvent(new Event("render-event"));
  }
});



// WEBPACK FOOTER //
// ./src/main.js